/* eslint-disable react/jsx-props-no-spreading -- wrappers here forward props wholesale */
import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import { BasicContent } from './BasicContent';
import RichText from './RichText';
import { CalculatorCellulose } from '../../ProPink/CalculatorCellulose';
import Container from '../oc-container';

const CMSCelluloseCalculator = ({ ...content }) => {
  const store = ReactOnRails.getStore('Store');

  return (
    <>
      <BasicContent {...content.copy} />
      <Provider store={store}>
        <Container maxWidth="1170">
          <CalculatorCellulose />
        </Container>
      </Provider>
      <RichText content={content.footnotes} />
    </>
  );
};

export default CMSCelluloseCalculator;
